import React from 'react';
import { connect } from 'react-redux';
import cancelIcon from '../../assets/images/close-icon.svg';
import dataModel from '../../models/DataModel';
import anime from 'animejs';
import BaseComponent from '../../baseClasses/BaseComponent';
import SelectUserComboBox from '../../components/SelectUserComboBox';
import userService from '../../services/userService';

import './ChangeTeamLeadPopup.scss';

class ChangeTeamLeadPopup extends BaseComponent{
 
  constructor(props){
    super(props);
    this.state = {
      editedContact: Object.assign({}),
      usersShareSameMarket: null,
      changed: false,
      newUser: 0,
      newUser_rol: 'none',
    };
    this.closePopup = this.closePopup.bind(this);
    	this.collapsePopup = this.collapsePopup.bind(this);
    this.setUsersWhoShareSameMarket = this.setUsersWhoShareSameMarket.bind(this);
  }

  componentDidMount(){
    dataModel.setDisableAppBackground(true);
    this.setUsersWhoShareSameMarket(this.props.currentUser);
  }

  async setUsersWhoShareSameMarket(user){
    const sameMarketUsers =  await userService.getUserByMarket(user.primary_company_id, user.markets);
    this.setState({
      usersShareSameMarket: sameMarketUsers.data,
    });
  }

  expandPopup() {
    return anime({
      targets: this.changeLeadPopup,
      height: this.props.currentUser.super_admin ? 414 : 364,
      easing: 'easeInOutCubic',
      duration: 200,
    });
  }

  collapsePopup(e, force) {
    return anime({
      targets: this.changeLeadPopup,
      height: 0,
      easing: 'easeInOutCubic',
      duration: 100,
      complete: () => {
        this.closePopup();
      },
    });
  }

  closePopup() {
    dataModel.setDisableAppBackground(false);
    const { handleClosePopup } = this.props;
    if (handleClosePopup) {
      handleClosePopup();
    }
  }

  handleChangeTeamLead(){
    this.props.currentUser.suspended = true;
    this.props.currentUser.replacement_user_id= this.state.newUser;
    this.props.currentUser.newuser_rol=this.state.newUser_rol;
    dataModel.usersDAO.updateUser(this.props.currentUser).then((response) => {
      dataModel.usersDAO.deleteUser(this.props.currentUser);
      dataModel.setDisableAppBackground(false);
      window.location.reload();
      const { handleClosePopup } = this.props;
      if (handleClosePopup) {
        handleClosePopup();
      }
    });
  }

  handleContactChanged(type, optionSelected) {
    let { editedContact } = this.state;
    if (optionSelected.selected) {
      let newUser_rol=optionSelected.user.role.name;
      editedContact.user = optionSelected.user;
      this.state.newUser=optionSelected.user.id;
      this.state.newUser_rol=newUser_rol;  
      this.setState({ changed: true, editedContact });
    }
    else{
      editedContact.user = null;
      this.state.newUser = 0;
      this.setState({ changed: false, editedContact });
    }
  }

  createContainer(){
    const usertoChange = this.props.currentUser;
    const userRoles = this.props.userRoles;
    let listUsers = [];

    if(this.state.usersShareSameMarket){
      this.state.usersShareSameMarket.forEach(user=>{
        const userRole = userRoles.find(role=> role.id === user.attributes.role_id);
        user.attributes.role = userRole;
        listUsers.push(user.attributes);
      });
    }

    return(
			<div className={'change-popup-container'}>
				<p className='caption'>Please select a user to replace {this.props.currentUser && this.props.currentUser.name} with: </p>
				<p className='caption2'>Search with username if you can't find the intended user in the below dropdown list: (Only users with common markets can be replaced) </p>
				<SelectUserComboBox
					users={listUsers}
					menuHeight={200}
					handleSelection={this.handleContactChanged}
					currentSelectedUser={this.state.editedContact.user}
					multiSelect={false}
					small={true}
					searchHint={'Search Directory'}
					height={24}
					width={240}
					numberPerPage={this.props.numberPerPage}
					autoFocusSearchBar={true}
					editUserDetails={this.props.editUserDetails}
					actualMarket={usertoChange.markets}
				/>
			</div>
		);
  }

  render(){

    let container = null;

    container = this.createContainer();

    return(
			<div className='change-lead-popup' ref={el => this.changeLeadPopup = el}>
				<header className='change-lead-popup__header' 
        style={{ backgroundColor: '#184E78' }}>
          <div className='caption'  style={{ color: 'white' }}>
						CHANGE TEAM LEAD
          </div>
          <div className='close-button'>
            <img
              src={cancelIcon}
              alt="cancel"
              className='close-button'
              onClick={this.collapsePopup}
            />
          </div>
        </header>
				<section className='change-lead-popup__container'>
          {container}
        </section>
				<div className='change-lead-popup__button-container'>
					<button
						className={'cancel-button'}
						onClick={this.collapsePopup}
					>
						CANCEL
					</button> 
					<button
						className={'change-lead-button'}
						onClick={this.handleChangeTeamLead}
					>
						REPLACE AND DELETE
					</button>         
        </div>
			</div>
		);
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    userRoles: state.new_users.userRoles,
  };
};

export default connect(mapStateToProps)(ChangeTeamLeadPopup);



// WEBPACK FOOTER //
// ./src/components/ChangeTeamLeadPopup/index.js